import { ref, watch, type Ref } from 'vue'

/**
 * localStorage와 양방향 동기화되는 ref를 반환한다.
 * 페이지 재방문 시 이전 입력값이 기본값으로 복원된다.
 */
export function useLocalInput(key: string, defaultValue: string): Ref<string> {
  const stored = localStorage.getItem(key)
  const value = ref(stored !== null ? stored : defaultValue)

  watch(value, (newVal) => {
    localStorage.setItem(key, newVal)
  })

  return value
}
